// 005 (FR-032, FR-033): loads the parent's cart when the parent area mounts and whenever the app
// comes back to the foreground, so the badge and summaries show the server's cart.
import { useEffect } from "react";
import { AppState } from "react-native";

import { useCart } from "./useCart";

export function CartSync() {
  const { actions } = useCart();
  useEffect(() => {
    void actions.load();
    const sub = AppState.addEventListener("change", (s) => {
      if (s === "active") void actions.load();
    });
    return () => sub.remove();
  }, [actions]);
  return null;
}
